<div class="c-acc-panel c-acc-panel--read" data-cy="personalized-coaching-panel">
  <div class="c-acc-panel__item">
    <div class="c-acc-panel__label">
      <span data-cy="personalized-coaching-label">{{ 'MY-ACCOUNT/MY-PRIVACY.AllowPersonalizedCoaching' | translate}}</span>
    </div>
    <div class="c-acc-panel__value" data-cy="personalized-coaching-value">
      @if (privacySettings.allowPersonalizedCoaching) {
        <span data-cy="personalized-coaching-value-yes">{{ 'MY-ACCOUNT/MY-PRIVACY.Yes' | translate}}</span>
      }
      @if (!privacySettings.allowPersonalizedCoaching) {
        <span data-cy="personalized-coaching-value-no">{{ 'MY-ACCOUNT/MY-PRIVACY.No' | translate}}</span>
      }
    </div>
    <div class="c-acc-panel__btn">
      <a class="c-link-ui" data-cy="personalized-coaching-change-btn" (click)="edit()">{{ 'MY-ACCOUNT.Change' | translate}}</a>
    </div>
  </div>
</div>
